import { LoanCategory } from '../../../../../../../../../../types/api';
import { PROPERTY_COMPANY_UPLOAD_RENT_ROLL_OR_PROVIDE_TENANT_INFO } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  IsLoanCategoryEqualTo,
  RentRollOrTenantInfoAnswerIs,
  RulesetResult,
} from '../rules';

class PropertyCompanyRentRollRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const selectedUploadRentRoll = RentRollOrTenantInfoAnswerIs.setAnswer(
      PROPERTY_COMPANY_UPLOAD_RENT_ROLL_OR_PROVIDE_TENANT_INFO.UPLOAD_RENT_ROLL
    ).evaluate(data);

    const isExpressPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PROPCO
    ).evaluate(data);

    if (selectedUploadRentRoll && !isExpressPropCo) {
      return RulesetResult.REQUIRED;
    }
    return RulesetResult.OPTIONAL;
  };
}

export default new PropertyCompanyRentRollRuleset();
